import auth from "../../middlewares/auth";
export const otherRoutes = [
    {
        path: '/chat',
        component: () => import(/* webpackChunkName: "others" */ '../../views/chat/Index.vue'),
        name: 'chat',
        meta: {
            middleware: [
                auth
            ],
        }
    },
    {
        path: '/roles',
        component: () => import(/* webpackChunkName: "chat_settings" */ '../../views/settings/roles/Index'),
        name: 'roles',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['roles-manage']
        }
    },
];